const BASE_ROUTE = "/forms";

export const FORMS_ROUTE = {
  BASE: BASE_ROUTE,
  CHECK_IN: `${BASE_ROUTE}/check-in`,
  DIETITIAN: `${BASE_ROUTE}/dietitian`,
} as const;
